class ExceptionHandler {
	
	public handleError(oError: Error): void {
		// Implement your error handling logic here
		console.error("An error occurred:", oError);
	}  
}

export default ExceptionHandler;
